/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Pricing_DescriptionInputs */

const en_meta_pricing_description = /** @type {(inputs: Meta_Pricing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare paid Listening plans. Turn papers, articles, and your own text into audio, with Zotero, browser, mobile, and desktop apps.`)
};

const es_meta_pricing_description = /** @type {(inputs: Meta_Pricing_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compara los planes de pago de Listening. Convierte artículos y tus propios textos en audio, con Zotero y aplicaciones para navegador, móvil y escritorio.`)
};

/**
* | output |
* | --- |
* | "Compare paid Listening plans. Turn papers, articles, and your own text into audio, with Zotero, browser, mobile, and desktop apps." |
*
* @param {Meta_Pricing_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const meta_pricing_description = /** @type {((inputs?: Meta_Pricing_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Pricing_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_meta_pricing_description(inputs)
	return en_meta_pricing_description(inputs)
});